import React from "react";
import { Link } from "react-router-dom";

const NAVY    = "#1A2B4A";
const NAVY_2  = "#243B66";
const CRIMSON = "#7C1414";
const CRIMSON_2 = "#A52323";
const GOLD    = "#C8991A";

const accreditations = [
  { label: "NAAC", img: "/images/icons/naac-logo.png", href: "http://naac.gov.in/index.php/en/", external: true },
  { label: "UGC",  img: "/images/icons/ugc.jpeg",      href: "https://www.ugc.ac.in/",            external: true },
  { label: "GU",   img: "/images/icons/idol.jpeg",     href: "https://www.gauhati.ac.in/",        external: true },
];

const distanceLearning = [
  { label: "KKHSOU", img: "/images/icons/kkhou.jpg", to: "/kkhsou" },
  { label: "GUCDOE", img: "/images/icons/idol.jpeg", to: "/gucdoe" },
  { label: "IGNOU",  img: "/images/icons/ignou.jpg", to: "/ignou" },
];

function PartnerCard({ label, img }) {
  return (
    <div className="ps-card">
      <div className="ps-card__accent" />
      <div className="ps-card__logo-wrap">
        <img src={img} alt={`${label} logo`} className="ps-card__logo" />
      </div>
      <div className="ps-card__label">{label}</div>
    </div>
  );
}

function SectionBlock({ eyebrow, title, accent, items, renderItem }) {
  return (
    <div
      className="ps-block"
      style={{
        background: accent.bg,
      }}
    >
      <div className="ps-block__inner">
        <div className="ps-block__header">
          <div className="ps-block__eyebrow">{eyebrow}</div>
          <h3 className="ps-block__title">{title}</h3>
          <div className="ps-block__rule" />
        </div>
        <div className="ps-block__cards">
          {items.map((it, i) => renderItem(it, i))}
        </div>
      </div>
    </div>
  );
}

export default function PartnershipStrip() {
  return (
    <section className="ps-strip">
      <SectionBlock
        eyebrow="Recognized By"
        title="Awards & Accreditations"
        accent={{ bg: `linear-gradient(135deg, ${NAVY} 0%, ${NAVY_2} 100%)` }}
        items={accreditations}
        renderItem={(it, i) => (
          <a
            key={i}
            href={it.href}
            target="_blank"
            rel="noopener noreferrer"
            className="ps-link"
          >
            <PartnerCard label={it.label} img={it.img} />
          </a>
        )}
      />

      <SectionBlock
        eyebrow="Continuing Education"
        title="Distance Learning & Online Courses"
        accent={{ bg: `linear-gradient(135deg, ${CRIMSON} 0%, ${CRIMSON_2} 100%)` }}
        items={distanceLearning}
        renderItem={(it, i) => (
          <Link key={i} to={it.to} className="ps-link">
            <PartnerCard label={it.label} img={it.img} />
          </Link>
        )}
      />

      <style>{`
        .ps-strip {
          font-family: 'Lato', sans-serif;
        }
        .ps-block {
          border-top: 3px solid ${GOLD};
          position: relative;
        }
        .ps-block + .ps-block {
          border-top: 3px solid ${GOLD};
        }
        .ps-block__inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 36px 24px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 32px;
          flex-wrap: wrap;
        }
        .ps-block__header {
          flex: 0 0 auto;
          max-width: 380px;
        }
        .ps-block__eyebrow {
          color: ${GOLD};
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 2px;
          text-transform: uppercase;
          margin-bottom: 8px;
        }
        .ps-block__title {
          color: #fff;
          font-family: 'Playfair Display', Georgia, serif;
          font-size: 26px;
          font-weight: 700;
          margin: 0;
          letter-spacing: 0.3px;
          line-height: 1.2;
        }
        .ps-block__rule {
          width: 56px;
          height: 3px;
          background: ${GOLD};
          margin-top: 12px;
          border-radius: 2px;
        }
        .ps-block__cards {
          display: flex;
          gap: 16px;
          flex-wrap: wrap;
        }
        .ps-link {
          text-decoration: none;
          color: inherit;
          display: block;
        }
        .ps-card {
          position: relative;
          width: 130px;
          height: 130px;
          background: #fff;
          border-radius: 10px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 14px 10px 12px;
          box-shadow: 0 4px 16px rgba(0,0,0,0.18);
          transition: transform 0.22s ease, box-shadow 0.22s ease;
          overflow: hidden;
          cursor: pointer;
        }
        .ps-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 10px 26px rgba(0,0,0,0.28);
        }
        .ps-card__accent {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 3px;
          background: ${GOLD};
          transform: scaleX(0.35);
          transform-origin: left center;
          transition: transform 0.25s ease;
        }
        .ps-card:hover .ps-card__accent {
          transform: scaleX(1);
        }
        .ps-card__logo-wrap {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
        }
        .ps-card__logo {
          max-width: 64px;
          max-height: 56px;
          width: auto;
          height: auto;
          object-fit: contain;
        }
        .ps-card__label {
          font-family: 'Lato', sans-serif;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 1px;
          color: ${NAVY};
          text-transform: uppercase;
          margin-top: 8px;
        }
        @media (max-width: 900px) {
          .ps-block__inner {
            justify-content: center;
            text-align: center;
            gap: 24px;
          }
          .ps-block__rule {
            margin-left: auto;
            margin-right: auto;
          }
          .ps-block__cards {
            justify-content: center;
          }
        }
        @media (max-width: 480px) {
          .ps-card {
            width: 100px;
            height: 110px;
          }
          .ps-card__logo {
            max-width: 50px;
            max-height: 44px;
          }
          .ps-card__label {
            font-size: 11px;
          }
          .ps-block__title {
            font-size: 22px;
          }
        }
      `}</style>
    </section>
  );
}
